<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jouoQJ/tc-custom/9781449457365.jpg?1729082774177" alt="This image is the cover for the book Frazz 3.14, Frazz Collections"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frazz 3.14, Frazz Collections
      </h1>
      <p class="bookDescription body article font2">
        <p>Nominated by the National Cartoonist Society as Best Comic Strip, Jef Mallett's <i>Frazz</i> follows the life of Bryson Elementary School janitor and hit-songwriting-wonder Edwin Frazier. An all-round Renaissance man, role model, and friend rolled into one, Frazz feels as comfortable philosophizing with the students as he is with the teachers and principal.</p><p>Always placing an emphasis on the importance of seizing opportunities to learn and grow, <i>Frazz</i> is a family favorite and multiple-year recipient of the Wilbur Award from the Religion Communicators Council for excellence in communicating values and ethics.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jef Mallett
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b534398a